import { getSettingsServiceByIdApi as generatedGetSettingsServiceByIdApi } from '../generated/settingsServices/getSettingsServiceById';

const getSettingsServiceByIdApi = generatedGetSettingsServiceByIdApi.enhanceEndpoints({
  endpoints: {
    getSettingsServiceById: {
      providesTags: (_result, _error, { serviceId }) => [{ id: serviceId, type: 'Services' }],
    },
  },
});

export const { useGetSettingsServiceByIdQuery } = getSettingsServiceByIdApi;
export { getSettingsServiceByIdApi };
